import { UserActivityContext } from ".";
import { useUserActivityState } from "../../hooks/useUserActivityState";
import { useVideoPlayerRefs } from "../VideoPlayerRefs";

interface Props {
  children: React.ReactNode;
}

export const UserActivityProvider = ({ children }: Props): JSX.Element => {
  const { container } = useVideoPlayerRefs();
  const isActive = useUserActivityState(container);

  return (
    <UserActivityContext.Provider value={isActive}>
      {children}
    </UserActivityContext.Provider>
  );
};
